  import { Injectable } from '@angular/core';
  import { Router } from '@angular/router';
  import { MessageDialogComponent } from '../screens/dialog-boxes/message-dialog/message-dialog.component';
  import { AppManagementService } from './app-management.service';
  import { HttpClient } from '@angular/common/http';
  import { Observable } from 'rxjs';
  import { MessageDialog } from '../objects/message-dialog';
  import { LoadingDialogComponent } from '../screens/dialog-boxes/loading-dialog/loading-dialog.component';
  import { MatDialog } from '@angular/material/dialog';
  import { PrivacyCheckDialogComponent } from '../screens/dialog-boxes/privacy-check-dialog/privacy-check-dialog.component';
  import { GoogleAnalyticsEventsService } from './google-analytics-events.service';
  import { MatSnackBar } from '@angular/material/snack-bar';
  import { AppTexts, TangentClassNames, ScreenNames } from '../objects/app-static-texts';

  declare var require: any
  const jp = require('jsonpath');

  @Injectable({
    providedIn: 'root'
  })
  export class CustomService {
    // PAGE VIEW COUNTER
    page_view_counter=0;

    preview_reco_url = "https://a.tangent.ai/shopify-builder/app/product-recommendation.html";
    
    // FLAG TO SET WHEN BACK BUTTON CLICKED
    backButtonClicked: boolean = false;

    // Global Response ID variable from server
    resp_id: any;

    // LOADED SCREEN PATH FOR EVENT TRACKING
    current_screen_path:any;

    // Redirect URL 
    redirect_url:any;

    data_for_redirection_event: any;

    server_updated_flag: boolean = false;
    server_response_recieved: boolean = false;

    custom_loader_base64:any;

    currentQuestion: any;
    navigator:any;
    browserName: string;
    selfieTags: string[];
    tags: string[];
    imageUrl: any;
    clickedBtn: any;
    selfieResponse: any;
    serverResponse: any;
    selectedOptions: any;
    customisedSR: any;
    selfieData_ForServer: any;

    // GLOBAL SHOP ID VARIABLE
    shopId:any;

    // GLOBAL FORM ID VARIABLE
    formId:any;

    clientConfig: any;
    selectedHighlightOption:any;

    selfie_data:any;

    api_detected_option:boolean = false;
    api_detected_opt_obj: any =null;
    selected_flag = false;

    messageDialog: MessageDialog;

    form: any = {};

    survey_input_resp:any = [];
    slugTextValue: string;
    surveyStarted: boolean = false;

    ai_selected_option_obj:any;
    
    data_for_server:any;

    selfie_face_attributes:any;

    constructor(
      private router: Router,
      public dialog: MatDialog,
      private appManagementService: AppManagementService,
      private http: HttpClient,
      private _snackBar: MatSnackBar,
      private googleAnalyticsService: GoogleAnalyticsEventsService
      ) {
      this.customisedSR = [];
      this.selfieTags = [];
      this.selfieData_ForServer = {};
      this.form = { value: {} };
      this.data_for_redirection_event = {};
    }

    // FUNCTION SELECTION FROM BUTTON
    triggerFunction(btn) {
      this.clickedBtn = btn;
      var fn = btn[AppTexts.functionName];
      switch (fn) {
        case 'redirect': {
          this.navigateToUrl(btn);
          if(btn.id=="btn-retry") {
            if(this.appManagementService.startScreen == ScreenNames.selfie){
              if(this.appManagementService.screenHistory.length>0){
                this.appManagementService.popFromScreenHistory(); 
              }
            } 
            this.appManagementService.popFromScreenHistory(); 
            this.appManagementService.scrollToTop();
          }
          break;
        }
        case 'previous_screen': {
          this.appManagementService.popFromScreenHistory();
          this.appManagementService.loadPrevious();
          this.appManagementService.scrollToTop();
          break;
        }
        case 'privacy_check': {
          this.clientConfig = this.appManagementService.client_config;
          this.openConsentDialog();
          break;
        }
        case 'open_dialog_box': {
          var dialogue_title = $localize`Sorry for interruption`;
          var dialogue_msg = $localize`We are on updating the service, sorry for the incovinence`;
          this.messageDialog = { title: dialogue_title, message: dialogue_msg};
          this.openMessageDialog(this.messageDialog);
          break;
        }
        case 'upload_image': {
          this.appManagementService.sentEventData(AppTexts.clickEventName,AppTexts.ButtonCategory,AppTexts.ClickAction,'Photo Upload','');
          break;
        }
        case 'upload_and_view': {
          this.appManagementService.sentEventData(AppTexts.clickEventName,AppTexts.ButtonCategory,AppTexts.ClickAction,'Photo Upload','');
          break;
        }
        case 'open_camera': {
          this.appManagementService.sentEventData(AppTexts.clickEventName,AppTexts.ButtonCategory,AppTexts.ClickAction,'Take Selfie','');        
          this.detectBrowser();
          break;
        }
        case 'skip_form': {
          this.form = { value: {} };
          this.appManagementService.sentEventData(AppTexts.clickEventName,AppTexts.ButtonCategory,AppTexts.ClickAction,'Continue without email','');
          this.navigateToUrl(btn);
          this.appManagementService.scrollToTop();
          break;
        }
        case 'skip_selfie': {
          this.surveyStarted = true;
          this.selfieResponse = null;
          this.selfie_data = null;
          // this.appManagementService.removeFromScreenHistory('selfie-result');
          this.appManagementService.sentEventData(AppTexts.clickEventName,AppTexts.ButtonCategory,AppTexts.ClickAction,'Continue without selfie','');          
          this.navigateToUrl(btn);
          this.appManagementService.scrollToTop();
          break;
        }
        case 'save_survey_inputs': {
          this.appManagementService.sentEventData(AppTexts.clickEventName,AppTexts.ButtonCategory,AppTexts.ClickAction,'Continue without email','');
          this.navigateToUrl(btn);
          this.appManagementService.scrollToTop();
          break;
        }
        case 'update_server': {
          try {
            
            this.saveToServer().subscribe(
              (data: {}) => {
                this.serverResponse = data;
                this.server_response_recieved = true;
              }, (error: {}) => {
                console.log('error : ', error);
                this.server_updated_flag = false;
                this.appManagementService.sentEventData(AppTexts.clickEventName,AppTexts.ButtonCategory,AppTexts.ClickAction,'Submit Quiz',0);          
              }
            );
          } catch (error) {
            this.server_updated_flag = false;
            this.appManagementService.sentEventData(AppTexts.clickEventName,AppTexts.ButtonCategory,AppTexts.ClickAction,'Submit Quiz',0);          
          }
          this.navigateToUrl(btn);
          this.appManagementService.scrollToTop();
          break;
        }
        case 'close': {
          this.generateRedirectURL(true);
          break;
        }
        case 'update_server_and_close': {
          try {          
            this.saveToServer().subscribe(
              (data: {}) => {
                this.serverResponse = data;
                this.server_response_recieved = true;
                this.generateRedirectURL(true);
              }, (error: {}) => {
                console.log('error : ', error);
                this.server_updated_flag = false;
                this.appManagementService.sentEventData(AppTexts.clickEventName,AppTexts.ButtonCategory,AppTexts.ClickAction,'Submit Quiz',0);          
              }
            );
          } catch (error) {
            this.appManagementService.sentEventData(AppTexts.clickEventName,AppTexts.ButtonCategory,AppTexts.ClickAction,'Submit Quiz',0);
          }
          break;
        }
        case 'update_server_and_send_recommendation_message':{
          try {          
            this.openLoadingDialog();
            this.saveToServer().subscribe(
              (data: {}) => {
                this.serverResponse = data;
                this.server_response_recieved = true;
                window.parent.postMessage(JSON.stringify(data), '*');
                this.closeDialog();
              }, (error: {}) => {
                this.server_updated_flag = false;
                console.log('error : ', error);
                this.appManagementService.sentEventData(AppTexts.clickEventName,AppTexts.ButtonCategory,AppTexts.ClickAction,'Submit Quiz',0);
              }
            );
          } catch (error) {
            this.appManagementService.sentEventData(AppTexts.clickEventName,AppTexts.ButtonCategory,AppTexts.ClickAction,'Submit Quiz',0);
          }
          break;
        }
        case 'load_screen': {
          this.surveyStarted = true;
          this.navigateToUrl(btn);
          this.appManagementService.scrollToTop();
          break;
        }
        case 'load_previous_question': {
          this.surveyStarted = true;
          this.backButtonClicked = true;
          this.navigateToUrl(btn);
          this.appManagementService.scrollToTop();
          break;
        }
        case 'load_next_question': {
          this.surveyStarted = true;
          var opt = {
            type:AppTexts.screen,
            screen_name: 'selfie-result'
          }
          this.checkForDuplicateAndAdd(opt);
          this.navigateToUrl(btn);
          this.appManagementService.scrollToTop();
          break;
        }
        case 'send_post_call2client': {
          if(this.appManagementService.getClientConfig().client_server_url!=undefined){
            window.parent.postMessage(this.data_for_server, '*');
          }
          break;
        }
        case 'save_form_data': {
          var app_load_id = this.appManagementService.getAppLoadId();
          var data = {
            "shop_id": app_load_id.shop_id,
            "form_id": app_load_id.form_id,
            "responses": {
              "parent_url": this.appManagementService.parent_url,
              "form": this.form.value
            }
          };
          if(this.resp_id!=null) { data[AppTexts.response_id]= this.resp_id; }
          var data_string = JSON.stringify(data);
          this.sync_server(data_string).subscribe(
            (data: {}) => {
              this.resp_id = data[AppTexts.response_id];
              this.navigateToUrl(btn);
              this.appManagementService.scrollToTop();
            }, (error: {}) => {
              console.log('error : ', error);
              this.appManagementService.sentEventData(AppTexts.clickEventName,AppTexts.ButtonCategory,AppTexts.ClickAction,'Submit Quiz',0);
            }
          );
          break;
        }
        default: {
          break;
        }
      }
    }

    // Navigation URL
    navigateToUrl(btn) {
      this.appManagementService.setNextPageId(btn['action-url-page-id']);
      if(this.appManagementService.getPageDesign()!=undefined) {
        this.router.navigate(["/"+ this.appManagementService.getPageDesign().name], { queryParamsHandling: 'preserve' });
        this.appManagementService.scrollToTop();
      }
    }

    loadSelfieHome() { 
      this.appManagementService.setNextPageId(ScreenNames.selfie);
      this.router.navigate(["/"+ScreenNames.selfie], { queryParamsHandling: 'preserve' });
      this.appManagementService.scrollToTop();
    }

    routeToScreen(screen_name){
      this.appManagementService.setNextPageId(screen_name);
      this.router.navigate(["/"+ screen_name], { queryParamsHandling: 'preserve' });
      this.appManagementService.scrollToTop();
    }

    loadSurveyScreen(){
      this.surveyStarted = true;
      this.appManagementService.setNextPageId(ScreenNames.survey);
      this.router.navigate(["/"+ScreenNames.survey], { queryParamsHandling: 'preserve' });
      this.appManagementService.scrollToTop();
    }

    setClickedBtn(btn) { this.clickedBtn = btn; }

    // Message POPUP
    openMessageDialog(msg) {
      this.dialog.open(MessageDialogComponent, {
        data: {
          title: msg.title,
          message: msg.message
        }
      });
    }

    openConsentDialog(){
      var eStyle = this.appManagementService.applyElementStyle(this.clientConfig.privacy_policy);
      var button_style = this.appManagementService.applyElementStyle(this.clientConfig.privacy_policy.confirm_button);
      const dialogRef = this.dialog.open(PrivacyCheckDialogComponent, 
        { 
          disableClose: true,
          data:{
            message: this.clientConfig.privacy_policy.text,
            custom_code:this.clientConfig.privacy_policy.custom_code,
            url: this.clientConfig.privacy_policy.original_url,
            url_text: this.clientConfig.privacy_policy.original_url_text,
            eleStyle: eStyle,
            btnStyle: button_style,
            btnText:this.clientConfig.privacy_policy.confirm_button.text
          } 
      });
      dialogRef.afterClosed().subscribe(result => {
        this.navigateToUrl(this.clientConfig.privacy_policy.confirm_button);
      });
    }

    // Loading Popup Screen
    openLoadingDialog() {
      var loadingText = $localize`Please wait...`;
      this.dialog.open(LoadingDialogComponent, {
        data: {
          title: loadingText,
          message: ''
        }
      });
    }

    openRedirectLoadingDialog(){
      this.dialog.open(LoadingDialogComponent, {
        data: {
          title: 'Redirecting',
          message: 'Please wait..'
        }
      });
    }

    // OPENING CAMERA DIALOG
    openCameraDialog() {
      if(this.clickedBtn.name == ScreenNames.survey){
        
      }
      else{
        this.appManagementService.setNextPageId(ScreenNames.camera);
        this.router.navigate(["/"+ScreenNames.camera], { queryParamsHandling: 'preserve' });
        this.appManagementService.scrollToTop();
      }
      
    }

    // Close any/all Popups
    closeDialog() { this.dialog.closeAll(); }

    // UPLOADED IMAGE CONVERSION
    baseConversion(file) {
      var mimeType = file.type;
      if (mimeType.match(/image\/*/) == null) {
        return; 
      }

      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (_event) => {
        this.imageUrl = reader.result;
        this.getImageDataApi();
      }
    }

    // Getter for base64 image
    getImageUrl() { return this.imageUrl; }

    // Selfi API Call Function
    getImageDataApi() {
      
      // If Uploaded Image view required
      if(this.clickedBtn[AppTexts.functionName] == AppTexts.uploadAndView || this.clickedBtn[AppTexts.functionName] == AppTexts.openCamera){
        this.appManagementService.setNextPageId(AppTexts.uploadScreen);
        if(this.appManagementService.getPageDesign()!=undefined){
          this.router.navigate(["/"+ this.appManagementService.getPageDesign().name], { queryParamsHandling: 'preserve' });
          this.appManagementService.scrollToTop();
        }
      }

      // Close all Existing popups
      this.dialog.closeAll();

      if(this.clickedBtn.loader!=undefined){
        this.custom_loader_base64 = this.appManagementService.getCustomLoader(this.clickedBtn.loader);
      }
      else{ this.openLoadingDialog(); }
      
      this.getImageData().subscribe(
        (data: {}) => {
          this.dialog.closeAll();
          
          // Global selfie response storage
          this.selfieResponse = data;
          
          this.appManagementService.sentEventData(AppTexts.clickEventName,AppTexts.ButtonCategory,AppTexts.ClickAction,'Submit Selfie',1);
          this.appManagementService.sentEventData('load',AppTexts.ButtonCategory,'API','Selfie Response',data);
          if(data!=undefined || data!=null){
            if(data["response"]!=undefined){
              if(data["response"].length>1){
                this.openClosePopupMessage("Multiple face detected","We can see multiple people, please upload a photo with just your selfie!");
                this.loadSelfieHome();
              }
              else{
                this.extractVisualElements(data);
            
                //Sending values to Analytics dashboard
                this.updateToAnalytics(data);
                this.selfieResponse["img"] = this.imageUrl;
                if(this.clickedBtn['action-url-page-id']== ScreenNames.survey){
                  this.surveyStarted = true;
                  var opt = { type:AppTexts.screen, screen_name: ScreenNames.selfie }
                  this.checkForDuplicateAndAdd(opt);
                }
                this.navigateToUrl(this.clickedBtn);
                this.appManagementService.scrollToTop();
                this.fetchServerReqDataFromSelfie();
              }
            }
            else{
              if(this.appManagementService.getClientApiType() == 'hair'){
                this.selfie_data = data;
                this.selfieResponse["img"] = this.imageUrl;
                this.navigateToUrl(this.clickedBtn);
                this.appManagementService.scrollToTop();
                this.fetchServerReqDataFromSelfie();
              }
            }
          }
          else{
            if(this.appManagementService.getClientApiType() == 'hair'){
              this.openClosePopupMessage("Error","Could not detect the hair. Please check the guidelines and try again!");
            }
            else{
              this.openClosePopupMessage("Oops! Something went wrong!","Please try again later if you face the issue multiple times!");
            }
            this.loadSelfieHome();
          }
        },
        (error: {}) => {
          this.dialog.closeAll();
          console.log('error : ', error);
          this.appManagementService.sentEventData(AppTexts.clickEventName,AppTexts.ButtonCategory,AppTexts.ClickAction,'Submit Selfie',0);
          this.openClosePopupMessage("Error","Could not detect the face. Please check the guidelines and try again!");
          this.loadSelfieHome();
        }
      );
    }

    openClosePopupMessage(ttl,msg){
        var msgObj = {
          title: ttl,
          message: msg
        };
        this.openMessageDialog(msgObj);
        setTimeout(() => {
          this.dialog.closeAll();
        }, 4000);
    }

    // Getter for Selfi API response structured data
    getSelfieResult() { return this.customisedSR; }

    // Setter for base64 image
    setImageUrl(url) { this.imageUrl = url; }

    // Server AI Image Data Request
    getImageData(): Observable<Response> {
      var dataJson = { "imageBS64": this.imageUrl, "user": this.appManagementService.client_config.user, "essential_only": true };
      var localUrl = this.appManagementService.client_config.api_url;
      this.customisedSR = [];
      var httpOptions = this.appManagementService.getSelfiApiCallHeaders();
      return this.http.post<Response>(localUrl, dataJson, httpOptions);
    }

    extractVisualElements(data) {
      this.selfie_face_attributes = data.response[0]["faceAttributes"];
      this.selfie_data = data.response[0];
      var displayEleList = this.appManagementService.getConfiguratonDisplay();
      
      //ELEMENTS TO DISPLAY IN SELFIE RESULT
      if(displayEleList!=undefined){
        for (var de = 0; de < displayEleList.length; de++) {
          var feature = displayEleList[de].domain_key;
          
          var jp_key_search;
              
          //Search using JSON Path
          jp_key_search = '$..'+feature;

          if(this.selfie_data!=undefined){

            //JSON Path Search for matching selfi tag
            var jp_result = jp.nodes(this.selfie_data, jp_key_search);
    
            if(jp_result!=undefined && jp_result.length>0){
    
              var val = null;
              switch (feature) {
                case 'emotion': {
                  val = { key: feature, value: this.getProminantEmotion(this.selfie_face_attributes[feature]) };
                  break;
                }
                case 'hair': {
                  val = { key: feature , value: this.getProminantHair(this.selfie_face_attributes[feature], displayEleList[de]) };
                  break;
                }
                case 'makeup': {
                  var mkup = this.getMakeupApplied(displayEleList[de], this.selfie_face_attributes[feature]);
                  if (mkup != "") {
                    val = { key: feature, value: mkup }
                  }
                  else{
                    mkup = "No makeup";
                    val = { key: feature, value: mkup }
                  }
                  break;
                }
                case 'skinTone': {
                  var mappingObj =  this.appManagementService.getSkinToneMapping();

                  var final_val = jp_result[0].value; 
                  if(mappingObj!=undefined){
                    final_val = mappingObj[jp_result[0].value];
                  }
                  val = { key: feature, value: final_val };
                  break;
                }
                case 'candida_acne': {
                  val = { key: feature, value: this.selfie_data[feature] };
                  break;
                }
                case 'food_preservative_acne': {
                  val = { key: feature, value: this.selfie_data[feature] };
                  break;
                }
                case 'acne': {
                  val = { key: feature, value: this.selfie_data[feature] };
                  break;
                }
                case 'smile': {
                  break;
                }
                case 'facialHair': {
                  break;
                }
                case 'age': {
                  var ageRange = this.getAgeRange(displayEleList[de], this.selfie_face_attributes[feature]);
                  val = { key: feature, value: ageRange };
                  break;
                }
                default: {
                  val = { key: feature, value: this.selfie_face_attributes[feature] };
                  break;
                }
              }
              if (val != null) {
                this.customisedSR.push(val);
              }
            }
          }
        }
      }
    }

    getProminantEmotion(obj) {
      var max = 0;
      var emotion;
      for (var property in obj) {
        var temp = max;
        max = (max < parseFloat(obj[property])) ? parseFloat(obj[property]) : max;
        if (temp != max) {
          emotion = property;
        }
      }
      return emotion;
    }

    getProminantHair(obj, ele) {
      var max = 1;
      if(ele!=null){
        max = ele["max"];
      }
      var hair_color = "";
      var colorList = obj["hairColor"];
      if(colorList.length>1){
        for (var hc = 0; hc < max; hc++) {
          hair_color = hair_color + colorList[hc]["color"];
          if (hc < max - 2) {
            hair_color = hair_color + " , "
          }
          else if (hc < max - 1) {
            hair_color = hair_color + " & "
          }
          else {
          }
        }
      }
      else{
        hair_color = "Hair not detected";
      }
      return hair_color;
    }

    getMakeupApplied(displayEle, obj) {
      var makeUp = "";
      
      for (var key in obj) {
        
        if (obj[key]) {
          if (makeUp == "") {
            makeUp = displayEle.filter_text[key];
          }
          else {
            makeUp = makeUp + " & " + displayEle.filter_text[key];
          }
        }
      }
      return makeUp;
    }

    getAgeRange(displayEle,val){
      var filter_list = displayEle.filter_text;
      var return_text;
      if(displayEle.filter_text!=undefined){
        for(var f=0;f<filter_list.length;f++){
          if(filter_list[f].min!=undefined && filter_list[f].max!=undefined){
            if(val>=filter_list[f].min && val<=filter_list[f].max){
              return_text = filter_list[f].text;
            }
          }
          else if(filter_list[f].min!=undefined && filter_list[f].max==undefined){
            if(val>=filter_list[f].min){
              return_text = filter_list[f].text;
            }
          }
          else{
            if(val<=filter_list[f].max){
              return_text = filter_list[f].text;
            }
          }
        }
      }
      else{
        return_text = val;
      }
      return return_text;
    }

    saveSelectedQueries(selected) {
      this.surveyStarted = true;
      this.selectedOptions = selected;
      this.appManagementService.saveSelectedQueries(selected);
    }

    getSelectedQueries() { return this.selectedOptions; }

    submitFunction(ele, form){
      this.form = form;
      this.triggerFunction(ele);
    }

    // Fetch Data for Server to retrive from Selfie
    fetchServerReqDataFromSelfie(){
      var listKey = this.appManagementService.getServerReqDataFrmSelfie();
      if(listKey!=undefined){
        if (listKey.length > 0) {
          for (var lk=0;lk<listKey.length; lk++){
            var key_object = listKey[lk];
            if(this.selfie_data!=undefined){
              // COLLECT DATA FOR SERVER FROM SELFIE
              this.getDataForServerFromSelfie(key_object.api_key);
            }
          }
        }
      }
    }

    // SENDING SELFIE DATA FROM KEYS IN CONFIG TO SERVER
    getDataForServerFromSelfie(val){
      var feature = val.api_key;
      var jp_key_search = '$..'+feature;
      //JSON Path Search for matching selfi tag
      var jp_result = jp.nodes(this.selfie_data, jp_key_search);

      if(jp_result!=undefined && jp_result.length>0){
        var val = null;
        switch (feature) {
          case 'emotion': {
            val = { key: feature, value: this.getProminantEmotion(this.selfie_face_attributes[feature]) };
            break;
          }
          case 'hair': {
            val = { key: feature , value: this.getProminantHair(this.selfie_face_attributes[feature], null) };
            break;
          }
          case 'skinTone': {
            var mappingObj =  this.appManagementService.getSkinToneMapping();

            var final_val = jp_result[0].value; 
            if(mappingObj!=undefined){
              final_val = mappingObj[jp_result[0].value];
            }
            val = { key: feature, value: final_val };
            break;
          }
          case 'candida_acne': {
            val = { key: feature, value: this.selfie_data[feature] };
            break;
          }
          case 'food_preservative_acne': {
            val = { key: feature, value: this.selfie_data[feature] };
            break;
          }
          case 'acne': {
            val = { key: feature, value: this.selfie_data[feature] };
            break;
          }
          case 'age': {
            val = { key: feature, value: this.selfie_face_attributes[feature] };
            break;
          }
          default: {
            val = { key: feature, value: this.selfie_face_attributes[feature] };
            break;
          }
        }
        if (val != null) {
          this.selfieData_ForServer[""+val.key] = val.value;
        }

      }

    }

    //UPDATING DATA TO SERVER
    sendSurveyDatatoServer(): Observable<Response> {
      
      var app_load_id = this.appManagementService.getAppLoadId();
      this.generateRedirectURL(false);
      this.form.value.selfie_data = this.selfieData_ForServer;
      var id;
      if (this.selfieResponse!=undefined){
        id = this.selfieResponse.id;
      }
      else {
        id = '';
      }

      // Final Data send to server
      var data = JSON.stringify({
        "shop_id": app_load_id.shop_id,
        "form_id": app_load_id.form_id,
        "responses": {
          "id": id,
          "selfie_user": this.appManagementService.client_config.user,
          "app_version": this.appManagementService.getAppVersion(),
          "parent_url": this.appManagementService.parent_url,
          "tags": this.generateTags(),
          "form": this.form.value,
          "raw_response": this.selectedOptions,
          "other_data":{
            "redirection_url": this.redirect_url
          }
        },
      });
      var localUrl = "https://service.tangent.ai/shopify/responses";

      var httpOptions = this.appManagementService.getSelfiApiCallHeaders();
      return this.http.post<Response>(localUrl, data, httpOptions);
    
    }

    saveToServer(){
      var app_load_id = this.appManagementService.getAppLoadId();
      this.generateRedirectURL(false);
      if(Object.keys(this.selfieData_ForServer).length !== 0){
        if(this.form!=undefined){
          this.form.value.selfie_data = this.selfieData_ForServer;
        }
        else{ 
          this.form = {
            value: {
              selfie_data:this.selfieData_ForServer
            }
          };
        }
      }
      var id;
      if (this.selfieResponse!=undefined){
        id = this.selfieResponse.id;
      }
      else {
        id = '';
      }

      for(var si=0;si<this.survey_input_resp.length;si++){
        for (const property in this.survey_input_resp[si]) {
          if(this.form!=undefined){
            this.form.value[property] = this.survey_input_resp[si][property];
          }
          else{ 
            this.form = {
              value: {
                property:this.survey_input_resp[si][property]
              }
            };
          }
        }
      }

      
      var data = {
        "shop_id": app_load_id.shop_id,
        "form_id": app_load_id.form_id,
        "responses": {
          "id": id,
          "selfie_user": this.appManagementService.client_config.user,
          "tags": this.generateTags(),
          "app_version": this.appManagementService.getAppVersion(),
          "form": this.form.value,
          "parent_url": this.appManagementService.parent_url,
          "raw_response": this.selectedOptions,
          "other_data":{
            "redirection_url": this.redirect_url
          }
        }
      }
      var eventData = {tags : data.responses.tags, form :  this.form.value};
      if(this.data_for_redirection_event!=undefined){
        if(this.data_for_redirection_event['final_tag']!=undefined){
          eventData['final_tag'] = this.data_for_redirection_event['final_tag']
        }
      }
      
      this.appManagementService.sentEventData(AppTexts.clickEventName,AppTexts.ButtonCategory,AppTexts.ClickAction,'Submit Quiz',eventData);

      // Response ID from selfie upload
      if(this.resp_id!=null){   
        data[AppTexts.response_id]= this.resp_id;
      }

      // Final Data send to server
      var data_string = JSON.stringify(data);

      this.data_for_server = data;
      this.server_updated_flag = true;
      return this.http.post<Response>(AppTexts.responseURL, data_string, this.appManagementService.apiCallHeaders);
    
    }

    //Fetching tags from selected options from survey
    generateTags() {
      
      var tags = [];
      if (this.selectedOptions != undefined) {
        for (var sq = 0; sq < this.selectedOptions.length; sq++) {
          var val = this.selectedOptions[sq];
          if(val.optVal!=undefined){
            var tg = val.optVal.tag;
            if (tg != 'null' && tg!=null && tg!="") {
              if(tg.includes('|')){
                var split_tags = tg.split("|");
                for (let t = 0; t < split_tags.length; t++) {
                  tags.push(split_tags[t]);
                }
              }
              else{
                tags.push(tg);
              }
            }
          }
        }
      }
      var apikeys = this.appManagementService.getApiToServerDataRequests();
      
      if(apikeys!=false){
        if(apikeys.length>0){
          for(var a=0;a<apikeys.length;a++){
            var jp_key_search;
            var api_data_relation_key = apikeys[a].api_key;
            if(api_data_relation_key=='custom_path'){
              jp_key_search = apikeys[a].custom_path;
            }
            else{
              jp_key_search = '$..'+api_data_relation_key;
            }
            var value;
          
            if(this.selfie_data!=undefined){
              //JSON Path Search for matching selfi tag
              var jp_result = jp.nodes(this.selfie_data, jp_key_search);
              if(jp_result!=undefined && jp_result.length>0){
                if(jp_result[0].value!=undefined){
                  value = jp_result[0].value;
                }
              }
              switch (apikeys[a].api_key) {
                case "hairColor":
                  if(value[0]!=undefined){
                    value = value[0].color;
                    if(apikeys[a].return == "original"){
                      tags.push(value);
                    }
                  }
                  break;
                case "age":
                  var tag_value = value;
                  if(apikeys[a].return == "original"){
                    tag_value = "Age_"+value;
                  }
                  if(apikeys[a].return == "modify"){
                    var opts = apikeys[a].options;
                    var matched = false;
                    for(var op=0;op<opts.length;op++){
                      if(opts[op].min_val!=undefined && !matched){
                        if(value>=opts[op].min_val){
                          matched = true;
                          tag_value = opts[op].tag_value;
                        }
                      }
                      if(!matched){
                        tag_value = opts[op].tag_value;
                      }
                    }
                  }
                  tags.push(tag_value);
                  break;

                case "ita":
                  var tag_value = value;
                  if(apikeys[a].return == "original"){
                    tag_value = "ita_"+value;
                    tags.push(tag_value);
                  }
                  if(apikeys[a].return == "modify"){
                    var opts = apikeys[a].options;
                    for(var op=0;op<opts.length;op++){
                      var matched = false;
                      if(opts[op].min_val!=undefined && opts[op].max_val!=undefined){
                        if(value>=opts[op].min_val && value <opts[op].max_val){
                          matched = true;
                          tag_value = opts[op].tag_value;
                          tags.push(opts[op].tag_value);
                        }
                      }
                    }
                  }
                  break;
  
                case "gender":
                  var tag_val = value;
                  if(value=="F"){
                    tag_val = "Female";
                  }
                  else if(value=="M"){
                    tag_val = "Male";
                  }
                  tags.push(tag_val);
                  break;

                case "ethnicity":
                  if(apikeys[a].return == "modify"){
                    var opts = apikeys[a].options;
                    var tag_val = value;
                    for(var op=0;op<opts.length;op++){
                      if(opts[op].api_match!=undefined){
                        if(value==opts[op].api_match){
                          tag_val = opts[op].tag_value;
                        }
                      }
                    }
                    tags.push(tag_val);

                  }
                  else{
                    tags.push(value);
                  }
                  
                  break;

                default:
                  if(apikeys[a].return == "original"){
                    tags.push(value);
                  }
                  else{
                    switch (apikeys[a].type) {

                      case "boolean":

                        var opts = apikeys[a].options;
                        var tag_val = value;

                        for(var op=0;op<opts.length;op++){
                          if(opts[op].api_match!=undefined){
                            
                            if(value==opts[op].api_match){
                              tag_val = opts[op].tag_value;
                              tags.push(tag_val);
                            }
                          }
                        }

                        break;

                      case "array_size":

                        if(jp_result[0].value > 0){
                          tags.push(apikeys[a].tag_value);
                        }
                        break;
                      // CASE 
                      case "condition_regions":
                        var loc_count = jp_result[0].value.loc.length;
                        for(var cl=0;cl<loc_count;cl++){
                          
                          var loc = jp_result[0].value.loc[cl];
                          if(loc.regions!=undefined){
                            if(loc.regions.length>0){
                              
                              if(!tags.includes(apikeys[a].tag_value)){
                                tags.push(apikeys[a].tag_value);
                              }

                              for(var r=0;r<loc.regions.length;r++){
                                var new_tag = apikeys[a].tag_value+"_"+loc.regions[r];
                                tags.push(new_tag);
                              }

                            }
                          }

                        }
                        break;

                      default:
                        tags.push(value);
                        break;
                    }

                  }
                  break;
              }
              
            }
      
          }

        }

      }
    
      // Default Tag for Tangent Quiz
      tags.push("tangent_quiz");
      //ADDING TAGS FROM SELFIE
      var finaltags = tags.concat(this.selfieTags);

      this.tags = finaltags;
      
      var function_name = this.appManagementService.getSubmitCallbackFunction();

      if(function_name!=undefined){
        this.callbackFunctions(function_name);
      }

      return finaltags;
    }

    getClickedBtn() { return this.clickedBtn; }

    resetValues() { this.selectedOptions.length = 0; }

    generateRedirectURL(redirect_status) {

      this.tags = this.generateTags();

      var redirectionData = this.appManagementService.getRedirectionData();
      this.redirect_url = redirectionData.default;
      if(this.redirect_url=="none"){
        if(redirectionData.iframe_msg!=undefined){
          this.appManagementService.sentPostMessageToParent(redirectionData.iframe_msg);
        }
      }
      else{
        if(this.appManagementService.previewQuiz){
          this.redirect_url =  this.preview_reco_url;
        }
        else{
          if(this.redirect_url=="/"){
            this.redirect_url = (window.location != window.parent.location)
                  ? document.referrer
                  : document.location.origin;
          }
        }
        if (redirectionData.auto_generate && !this.appManagementService.previewQuiz) {
          this.redirect_url = this.getAutoGeneratedURL(redirectionData);
        }
        else {
        
          var rules = redirectionData.rules;
          var flag = false;
        
          if(rules.length>0){
            for (var r = 0; r < rules.length; r++) {   
              var rule_tags = rules[r].tags;
              var count = 0;
              for (var t = 0; t < rule_tags.length; t++) {
                if (this.tags.includes(rule_tags[t])) {
                  count = count + 1;
                  if (count == rule_tags.length) {
                    flag = true;
                    this.redirect_url = rules[r].url;
                  }
                }
                else {
                  break;
                }
              }
              if (flag) {
                break;
              }
            }
          }
        }

        //Redirect url - adding params to the url
        if(redirectionData.enable_params){
          var params_to_add ="";
          for(var p=0;p<redirectionData.params.length;p++){
            var key = '$..'+redirectionData.params[p];
            if(this.selfieResponse!=undefined){
              var url_param_data = jp.nodes(this.selfieResponse, key);
              if(url_param_data.length>0){
                if(params_to_add.includes('?')){
                  params_to_add = params_to_add.concat('&'+redirectionData.params[p]+'='+url_param_data[0].value);
                }
                else{
                  params_to_add = params_to_add + '?'+redirectionData.params[p]+'='+url_param_data[0].value;
                }
              }
            }
            if(this.serverResponse!=undefined){
              var url_param_data_2 = jp.nodes(this.serverResponse, key);
              if(url_param_data_2.length>0){
                if(params_to_add.includes('?')){
                  params_to_add = params_to_add.concat('&'+redirectionData.params[p]+'='+url_param_data_2[0].value);
                }
                else{
                  params_to_add = params_to_add+ '?'+redirectionData.params[p]+'='+url_param_data_2[0].value;
                }
              }
            }
          }
        }
        if(this.redirect_url.includes('?')){
          params_to_add = params_to_add.replace('?','&');
        }
        
        this.redirect_url =  this.redirect_url + params_to_add;
        if(redirect_status){
          window.open(this.redirect_url, "_top");
        }
      }
    }

    // Custom Functions
    callbackFunctions(fn_name){
      switch (fn_name) {
        case "primally_custom_function":
          var most_occured_tag= this.mode(this.tags);

          var final_tag;
          switch (most_occured_tag) {
            case "oil_rich":
              final_tag = "final_oil_rich";
              break;
            case "dry":
              final_tag = "final_dry";
              break;
            case "sensitive":
              final_tag = "final_sensitive";
              break;
            case "balanced":
              final_tag = "final_balanced";
              break;
            default:
              
              break;
          }
          
          if(final_tag!=undefined){
            this.data_for_redirection_event['final_tag'] = final_tag;
            this.tags.push(final_tag);
          }
          break;
      
        default:
          break;
      }

    }

    // Find most occuring tag
    mode(array){
      // For upsell tag matching
      var check_conditions = ["oil_rich","balanced","sensitive","dry"];
      if(array.length == 0)
            return null;
        var modeMap = {};
        var maxEl = array[0], maxCount = 1;
        for(var i = 0; i < array.length; i++){
          var el = array[i];
          if(modeMap[el] == null){
            modeMap[el] = 1;
          }
          else{
            modeMap[el]++;  
            if(modeMap[el] > maxCount){
                maxEl = el;
                maxCount = modeMap[el];
            }
          }
        }

        var final_ele_tag;

        // If Upsell tag selected
        if(check_conditions.includes(maxEl)){
          final_ele_tag = maxEl;
        }
        else{
          // If non-upsell tag is selected 
          for(var cc=0;cc<array.length;cc++){
            if(check_conditions.includes(array[cc])){
              final_ele_tag = array[cc];
            }
          }
        }
        return final_ele_tag;
    }

    getAutoGeneratedURL(redirectionData) {
      var i, q;
      var url = redirectionData.demo_url;
      for (i = 0; i < url.length; i++) {
        if (url.charAt(i) == '{'){
          var qid = url.charAt(i+1);
          for (q = 0; q < this.selectedOptions.length; q++) {
            if(qid == this.selectedOptions[q].qId){
              url = url.replace('{'+qid+'}', this.selectedOptions[q].optVal.tag);
            }
          }
        }
      }
      return url;
    }

    resetAiSelected(){
      this.ai_selected_option_obj=null;
    }

    // Function to check the tag passed to it,from options in survey, has any api data relation match in the related tag field
    checkMatchWithSelfieTag(ui_tag) {
    
      var all_api_data_relations = this.appManagementService.getClientApiData();
      var api_data_relation_key;
      var api_data_obj;
      var api_data_relation_value;
      
      if(all_api_data_relations!=undefined){
        
        for(var ad=0; ad<all_api_data_relations.length; ad++){
          
          if(all_api_data_relations[ad].related_tag == ui_tag){
            
            api_data_relation_key = all_api_data_relations[ad].api_key;

            var jp_key_search;
            
            if(api_data_relation_key=='custom_path'){

              jp_key_search = all_api_data_relations[ad].custom_path;

            }
            else{
                
              //Search using JSON Path
              jp_key_search = '$..'+api_data_relation_key;

            }

            if(this.selfie_data!=undefined){

              //JSON Path Search for matching selfi tag
              var jp_result = jp.nodes(this.selfie_data, jp_key_search);
      
              if(jp_result!=undefined && jp_result.length>0){
      
                switch (all_api_data_relations[ad].response_type) {
          
                  case "boolean":

                      if(jp_result[0].value == 'True'){

                          api_data_obj = all_api_data_relations[ad];
                        
                      }

                    break;
                  case "text":

                    api_data_relation_value = all_api_data_relations[ad].response_value;
                    
                    if(jp_result[0].value!=undefined){

                      if(jp_result[0].value == api_data_relation_value){
    
                          api_data_obj = all_api_data_relations[ad];
                        
                      }

                    }

                  break;
                  case "array_size":
                    if(jp_result[0].value > 0){
    
                        api_data_obj = all_api_data_relations[ad];
                      
                    }
                    break;
                  case "value_greater":
              
                    if(all_api_data_relations[ad].check_value!=undefined){
                
                      if(jp_result[0].value > all_api_data_relations[ad].check_value){
      
                          api_data_obj = all_api_data_relations[ad];
                        
                      }

                    }
                    break;
                  case "value_lesser":
                  
                    if(all_api_data_relations[ad].check_value!=undefined){

                      if(jp_result[0].value < api_data_obj.all_api_data_relations[ad].check_value){
      
                          api_data_obj = all_api_data_relations[ad];
                        
                      }

                    }
                    break;
                  case "value_same":
                
                    if(all_api_data_relations[ad].check_value!=undefined){

                      if(jp_result[0].value == api_data_obj.all_api_data_relations[ad].check_value){
      
                          api_data_obj = all_api_data_relations[ad];
                        
                      }

                    }
                    break;
                  case "value_between":
                
                    if(all_api_data_relations[ad].min_value!=undefined && all_api_data_relations[ad].max_value!=undefined){

                      if(jp_result[0].value > all_api_data_relations[ad].min_value && jp_result[0].value <= all_api_data_relations[ad].max_value){
      
                          api_data_obj = all_api_data_relations[ad];
                        
                      }

                    }
                    break;
                  default:
                    break;
    
                }
    
              }
      
            }

          }

        }
      
      }


      return api_data_obj;
    
    }

    //Fetching Survey Next Button Style
    getSurveyNextButtonStyle() { 
      var style_classes = [
        "app-primary-button-bg", 
        TangentClassNames.tangentGlobalStyle,
        TangentClassNames.tangentGlobalStyleCustom,
        TangentClassNames.tangentPrimaryButton,
        TangentClassNames.tangentPrimaryButtonCustom,"tangent_survey_next_button_custom"];
      if(this.appManagementService.isMobile){
        style_classes.push(TangentClassNames.tangentGlobalStyleMobCustom);
        style_classes.push("tangent_primary_button_mob_custom");
        style_classes.push("tangent_survey_next_button_mob_custom");
      }
      return this.appManagementService.applyStyles(style_classes); 
    }

    //Fetching Loading Text Style
    getLoadingTextStyle() { 
      var style_classes = [
        TangentClassNames.tangentGlobalStyle,
        TangentClassNames.tangentGlobalStyleCustom,
        TangentClassNames.tangentLoadingTextCustom
      ];
      if(this.appManagementService.isMobile){
        style_classes.push(TangentClassNames.tangentGlobalStyleMobCustom);
        style_classes.push(TangentClassNames.tangentLoadingTextMobCustom);
      }
      return this.appManagementService.applyStyles(style_classes); 
    }
    
    // App Container Style
    getQuizContainerStyle() { 
      var style_classes = [TangentClassNames.tangentQuizContainerCustom];
      if(this.appManagementService.isMobile){
        style_classes.push(TangentClassNames.tangentQuizContainerMobCustom)
      }
      return this.appManagementService.applyStyles(style_classes); 
    }

    setHighlightedOption(option){ this.selectedHighlightOption = option; }

    setServerResponse(data){ this.serverResponse = data; }

    updateToAnalytics(data){
      var tracking_response_keys = ["skinTone","acne","gender","hairColor","age","Wavy_Hair","Gray_Hair","Straight_Hair","Heavy_Makeup","bald"];
        
      for(var k=0;k<tracking_response_keys.length;k++){

        var jp_search = '$..'+tracking_response_keys[k];
        
        var jp_result = jp.nodes(data, jp_search);

        if(jp_result!=undefined && jp_result.length>0){
          var property = '';
          var val;
          
          switch (tracking_response_keys[k]) {
            case "skinTone":
              property = 'client_skinTone';
              val = jp_result[0].value;
              break;

            case "acne":
              property = 'client_acne';
              
              val = jp_result[0].value;
              break;

            case "gender":
              property = 'client_gender';
              val = jp_result[0].value;
              break;

            case "hairColor":
              property = 'client_hair_color';
              if(jp_result[0].value.length>0){
                val = jp_result[0].value[0].color;
              }
              else{
                val = 'No color';
              }
              break;
            
            case "age":
              property = 'client_age';
              val = jp_result[0].value;          
              break;
            
            case "Wavy_Hair":
              property = 'client_wavy_hair';
              val = jp_result[0].value;
              break;
            
            case "Gray_Hair":
              property = 'client_grayHair';
              val = jp_result[0].value;
              break;
          
            case "Straight_Hair":
              property = 'client_straight_hair';
              val = jp_result[0].value;
              break;
              
            case "Heavy_Makeup":
              property = 'client_heavyMakeup';
              val = jp_result[0].value;
              break;
            
            case "bald":
              property = 'client_baldness';
              var temp = jp_result[0].value;
              if(temp>0.5){
                val = true;
              }
              else{
                val = false;
              }
              break;
                
            default:
              break;
          }
        }
        this.googleAnalyticsService.setDimensionValue(property,val); 
      }
    }

    slugText(str) {
      str = str.replace(/^\s+|\s+$/g, ''); // trim
      str = str.toLowerCase();
    
      // remove accents, swap ñ for n, etc
      var from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
      var to   = "aaaaaeeeeeiiiiooooouuuunc------";
      for (var i=0, l=from.length ; i<l ; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
      }
    
      str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes
      
      this.slugTextValue = str;
      
      return str;
    }

    // Page view  for analytics
    sendPageViewUpdate(screenName){
      if(this.appManagementService.previewQuiz==false){
        var path = screenName;
        if(screenName == ScreenNames.survey){
          path = this.slugTextValue;
        }
        this.current_screen_path =  '/quiz/'+this.formId+'/'+path;

        this.appManagementService.current_screen_path = this.current_screen_path;

        // Send Page title and Path 
        this.googleAnalyticsService.sentToGAView(screenName, this.current_screen_path);
        this.page_view_counter = this.page_view_counter + 1;
        
        var eVal;
        if(this.page_view_counter==2){
          eVal = {
            start_quiz:true
          };
        }
        else{
          eVal = '';
        }
        this.appManagementService.saveEventToServer('View','page_view',this.current_screen_path,eVal).subscribe(
          (data: {}) => {  }, (error: {}) => { console.log('error : ', error); }
        );
      }
      
    }

    setFormId(id) { this.formId = id; }

    setShopId(id) { this.formId = id; }

    //DETECTING BROWSER
    async detectBrowser() { 
      
      try {
        navigator.userAgent.toLowerCase();
        // @ts-ignore-start
        if(navigator.userAgent.toLowerCase().includes("duckduckgo") || (navigator.brave && await navigator.brave.isBrave() || false)){
          console.log("unsupported browser");
          var msg = {
              title: "Take a selfie",
              message: "Feature not available for this browser. Please use Photo Upload or switch to a different browser!"
            };
          this.openMessageDialog(msg);
        }
        else{
          this.openCameraDialog();
        }
        // @ts-ignore-end

      } catch (error) {
        console.log("Error detected ",error);
      }
    }

    saveSurveyForm(val){ this.survey_input_resp.push(val); }

    setFormKeyData(form_key: any, val: string) { this.form.value[form_key] = val; }
    
    setCurrentQuestion(quest: any) { this.currentQuestion = quest; }

    getCurrentQuestion(){ return this.currentQuestion; }

    isSurveyContinued() { return this.surveyStarted; }

    isBackButtonClicked() { return this.backButtonClicked; }

    setBackButtonClicked(val) { this.backButtonClicked = val; }

    getDatabySearch(keyname){
      var key = '$..'+keyname;
      var url_param_data = jp.nodes(this.selfieResponse, key);
      return url_param_data[0].value;
    }

    checkForDuplicateAndAdd(opt){
      if(this.selectedOptions!=undefined){
        var add_flag = true;
        for(var o=0;o<this.selectedOptions.length;o++){
          if(opt.type==this.selectedOptions[o].type){
            if(this.selectedOptions[o].type == AppTexts.screen && opt.screen_name == this.selectedOptions[o].screen_name){
              add_flag = false;
            }
            if(this.selectedOptions[o].type == AppTexts.question && opt.qName == this.selectedOptions[o].qName){
              add_flag = false;
            }
          }
        }

        if(add_flag){
          this.selectedOptions.push(opt);
        }
      }
    }

    // MESSAGE SNACK BAR
    openSnackBarMessage(message, postionValue, postion) {
      postionValue = postionValue +40;
      this._snackBar.open(message,'',{
        duration: 1500,
        horizontalPosition:'center',
      });
      var positionStyle ="";
      if(postion=='bottom'){
        positionStyle = "bottom:"+postionValue+"px!important";
      }
      else{
        positionStyle = "top:"+postionValue+"px!important";
      }
      document.getElementsByClassName("mat-snack-bar-container")[0].setAttribute("style",positionStyle);
    }

    // Inital Question load conditions based
    checkForApiResponseMapping(screen_load_filter){
      var s_name = "";
      
      var api_data_relation_value;
      for(var c=0;c<screen_load_filter.conditions.length;c++){
        
        var jp_key_search;

        jp_key_search = '$..'+screen_load_filter.conditions[c].api_key;

        if(this.selfie_data!=undefined){

          //JSON Path Search for matching selfi tag
          var jp_result = jp.nodes(this.selfie_data, jp_key_search);

          if(jp_result!=undefined && jp_result.length>0){
      
            api_data_relation_value = screen_load_filter.conditions[c].expected;
            
            if(jp_result[0].value!=undefined){

              if(jp_result[0].value == api_data_relation_value){
                
                s_name =  screen_load_filter.conditions[c].load;
                
              }

            }
            
          }

        }

      }
      return s_name;
    }

    sync_server(data) { return this.http.post<Response>(AppTexts.responseURL, data, this.appManagementService.apiCallHeaders); }

    getCustomLoader() { return atob(this.custom_loader_base64); }

  }